function saveRecipe(title, url, image) {
    let savedRecipes = JSON.parse(localStorage.getItem("saved_recipes") || "[]");

    // Prevent duplicates
    if (!savedRecipes.some(recipe => recipe.url === url)) {
        savedRecipes.push({ title, url, image });
        localStorage.setItem("saved_recipes", JSON.stringify(savedRecipes));
        alert("Saved successfully! ❤️");
    } else {
        alert("This is already saved!");
    }
}
